import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useQuery } from "react-query";
//prime react
import { Dropdown } from "primereact/dropdown";
import { Skeleton } from "primereact/skeleton";
//services
import { useContextSimulator } from "../../SimulatorContext";
import { useAppContext } from "../../../../../../context/AppContext";
import { getMapImage } from "../../../../../../services/GlobalRoles/getMapImage";

import EnterpriseMap from "../../../Map/Map";

const ModalBlockAndLand = ({ empId }) => {
  const {
    simulatorData,
    blocks,
    currentBlock,
    setCurrentBlock,
    lands,
    currentLand,
    setCurrentLand,
    fetchLandsSelect,
    setTestId,
    setSkeleton,
    discount,
    setLandValue,
  } = useContextSimulator();

  const { id } = useParams();
  // const { state } = useLocation(); // state.empId from enterprise

  const refId = id !== undefined ? id : empId;

  const [loadingBlocks, setLoadingBlocks] = useState(true);
  const [loadingLands, setLoadingLands] = useState(true);
  const [hideSelects, setHideSelects] = useState(false);
  const [message, setMessage] = useState("");

  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);

  const { data: hasMap } = useQuery({
    queryKey: [`map-image-${refId}`],
    queryFn: () => getMapImage(refId),
    retry: false,
    enabled: !!permissions?.includes("20")
  });

  useEffect(() => {
    if (!blocks) {
      setMessage(
        `Cadastre ${nomenclature[0].value} e ${nomenclature[1].value}`
      );
      setHideSelects(true);
      return;
    }
    setLoadingBlocks(false);
  }, [blocks]);

  useEffect(() => {
    if (lands) {
      setLoadingLands(false);
    }
  }, [lands]);

  useEffect(() => {
    if (simulatorData) {
      if (
        discount !== 0 &&
        parseFloat(discount) < parseFloat(simulatorData.land_value)
      ) {
        setLandValue(
          parseFloat(simulatorData.land_value).toFixed(2) -
          parseFloat(discount).toFixed(2)
        );
      } else {
        setLandValue(parseFloat(simulatorData.land_value).toFixed(2))
      }
    }
  }, [discount]);

  return (
    <div className="row">
      <div className="col-md-12 pb-2">
        <div className="card mb-3 p-3 bg-warning-300 rounded-3 bg-opacity-75">
          <span className="text-center">
            <i className="bi bi-info-circle-fill me-1"></i>
            <b>Atenção</b>
            <br />
            Selecione uma unidade para realizar uma simulação.
          </span>
        </div>
        {!hasMap?.file && !blocks && !loadingBlocks && message && (
          <div className="card mb-3 p-3 bg-red-300 rounded-3 bg-opacity-75">
            <span className="text-center">
              <i className="bi bi-info-circle-fill me-1"></i>
              <b>Atenção</b>
              <br />
              {message}
            </span>
          </div>
        )}

        {loadingBlocks && (
          <>
            <div className="row d-flex mb-3">
              <div className="col-md-6 col-sm-12">
                <label className="mb-3">{nomenclature[0].value}</label>
                <Skeleton width="100%" height="40px"></Skeleton>
              </div>
              <div className="col-md-6 col-sm-12">
                <label className="mb-3">{nomenclature[1].value}</label>

                <Skeleton width="100%" height="40px"></Skeleton>
              </div>
            </div>
          </>
        )}

        {blocks && (
          <div className="row mb-3">
            <div className="col-md-6 col-sm-12">
              <label className="mb-3">{nomenclature[0].value}</label>
              <Dropdown
                filter
                showClear
                value={currentBlock}
                onChange={(e) => {
                  setCurrentBlock(e.value);
                  fetchLandsSelect(e.value);
                }}
                options={blocks}
                disabled={loadingBlocks}
                placeholder={loadingBlocks ? "Carregando..." : "Selecione"}
                optionLabel="label"
                className="bg-none px-0 w-100"
              />
            </div>

            <div className="col-md-6 col-sm-12">
              <label className="mb-3">{nomenclature[1].value}</label>
              <Dropdown
                filter
                showClear
                value={currentLand}
                onChange={(e) => {
                  setCurrentLand(e.value);
                  setTestId(e.value);
                  setSkeleton(true);
                }}
                options={lands}
                optionLabel="label"
                disabled={loadingLands}
                emptyMessage="Não há lotes disponíveis nessa quadra"
                placeholder={
                  currentBlock && loadingLands ? "Carregando..." : "Selecione"
                }
                className="bg-none px-0 w-100"
              />
            </div>
          </div>
        )}

        {hasMap?.file && !loadingBlocks && (
          <div style={{ overflowX: "scroll" }}>
            <EnterpriseMap empId={empId} customAction={"simulator"} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalBlockAndLand;
